import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFounderAuth } from "../context/FounderAuthContext";
import { useAuth } from "../context/AuthContext";
import { isAuthenticatedPublisher } from "../services/authAccess";

type FounderGuestRouteProps = {
  children: ReactNode;
};

export function FounderGuestRoute({ children }: FounderGuestRouteProps) {
  const { user: founderUser, isLoading: founderLoading } = useFounderAuth();
  const { user: publisherUser, isLoading: publisherLoading } = useAuth();

  if (founderLoading || publisherLoading) {
    return (
      <div className="oac-founder-shell oac-founder-shell--loading">
        <p className="oac-founder-shell__loading">Loading...</p>
      </div>
    );
  }

  if (founderUser) {
    return <Navigate replace to="/founder/hub/overview" />;
  }

  if (isAuthenticatedPublisher(publisherUser)) {
    return <Navigate replace to="/" />;
  }

  return children;
}
